/* eslint-disable complexity */
/* eslint-disable new-cap */
/* eslint-disable no-unused-vars */
import Types from "./types";
import { CheckoutService, CheckoutDrivaService, UserAuthService, ThirdPartyService, CheckoutTradeInService, ListingServiceAU, B2cConsumerFinanceService, SignContractService, PaymentServiceAu, BffPaymentService, BffDataAU} from "../../../../service";
import { AUTH_ADDRESS, X_VEHICLE_TYPE } from "../../../../constants/api-constants";
import { formatDeliveryAddressToDrivaAddress } from "../../../../utils/helpers/format-address-object";
import { getPreApprovedPayload } from "../../../../utils/helpers/checkout-util";
import parseCookie from "../../../../utils/helpers/parse-cookie";
import { ORDER_STATUS, VEHICLE_STATE } from "../../../../constants/checkout-constants";
import { API_SOURCE, NUMBER, resetReducerKeys, EXTENDEDWARRANTY, REFERRER_SOURCE, CAR_LIST_EVENT_NAMES } from "../../../../constants/app-constants";
import carListingEventDataParserGA4, {parseFilterToDimensionGA4} from "../../../../tracking/parser/car-listing-ga4";
import carListingEventDataParser from "../../../../tracking/parser/car-listing";
import { getCarPrice, getTradePriceLabel } from "../../../../utils/helpers/calculate-egc-dap";
import { getLoanDepositAmount } from "../../../../utils/helpers/get-loan-deposit-amount";
import { showToast } from "../../../shared/toast-message/actions";
import { getSum } from "../../../../utils/helpers/split-payment";
import { trackDesktopCustomEventsAU, trackCustomReMarketingEvents, desktopCleverTapEvent, isFirstCleverTapOrderEvent } from "../../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../../tracking/au.desktop-events";
import { MARKETING_EVENTS_CONSTANTS } from "../../../../tracking/marketing-page-events";
import carListingAmplitude from "../../../../tracking/parser/car-listing-amplitude";
import { AMPLITUDE_EVENTS_CATEGORY } from "../../../../tracking/amplitude-events";
import { cleverTapBookingInitiated, CLEVERTAP_BOOKING_TYPE } from "../../../../tracking/parser/clevertap-details";
import { CLEVERTAP_EVENT_MAP } from "../../../../tracking/au.desktop-clevertap";

const populateCheckoutPersonalData = (userData) => ({
    type: Types.POPULATE_CHECKOUT_PERSONAL_DATA,
    userData
});

const setUserPersonalDetails = (personalDetails) => ({
    type: Types.SET_USER_PERSONAL_DETAILS,
    personalDetails
});

const setFinanceData = (data) => {
    return {
        type: Types.SET_FINANCE_DATA,
        data
    };
};

const setLoanDetails = (data) => {
    return {
        type: Types.SET_LOAN_DETAILS,
        newData: data
    };
};

const setLoanType = (data) => {
    return {
        type: Types.SET_LOAN_TYPE,
        newData: data
    };
};

const setPersonalDetailSuccessMessage = ({ successMessage }) => {
    return {
        type: Types.SET_PERSONAL_DETAIL_MESSAGE_FORM_ACTIVE,
        successMessage
    };
};

const setLoanTenureValue = ({ loanTenure }) => {
    return {
        type: Types.SET_LOAN_TENURE_VALUE,
        loanTenure
    };
};

const setCreditScoreValue = ({ creditScoreValue }) => {
    return {
        type: Types.SET_CREDIT_SCORE_VALUE,
        creditScoreValue
    };
};

const setDownPaymentValue = ({ downPaymentValue }) => {
    return {
        type: Types.SET_DOWNPAYMENT_VALUE,
        downPaymentValue
    };
};

const setMonthlyEmiValue = ({ monthlyEmiValue }) => {
    return {
        type: Types.SET_MONTHLY_EMI_VALUE,
        monthlyEmiValue
    };
};

const setFinanceSelectedValue = ({ financeSelected }) => {
    return {
        type: Types.SET_FINANCE_SELECTED,
        financeSelected
    };
};

const setMinMaxDownPaymentValue = ({ minDownpaymentValue, maxDownpaymentValue }) => {
    return {
        type: Types.SET_MIN_MAX_DOWNPAYMENT_VALUE,
        minDownpaymentValue,
        maxDownpaymentValue
    };
};

const setMinMaxEmiValue = ({ minEmiValue, maxEmiValue }) => {
    return {
        type: Types.SET_MIN_MAX_EMI_VALUE,
        minEmiValue,
        maxEmiValue
    };
};

const getOrderDetailInit = (data) => ({
    type: Types.GET_ORDER_DETAIL_INIT,
    isLoading: data
});

const getOrderDetailSuccess = (data) => ({
    type: Types.GET_ORDER_DETAIL_SUCCESS,
    data
});

const getOrderDetailFailure = (error) => ({
    type: Types.GET_ORDER_DETAIL_FAILURE,
    error
});

const getOrderDetail = (appointmentId, withLoader = true) => (dispatch, getState) => {
    dispatch(getOrderDetailInit(withLoader));
    const { user: { secureToken } } = getState();
    return new Promise((resolve, reject) => {
        CheckoutService.getOrderSummary(appointmentId, secureToken)
            .then(response => {
                dispatch(getOrderDetailSuccess(response.data));
                resolve(response.data);
            }).catch(error => {
                dispatch(getOrderDetailFailure(error));
                reject(error);
            });
        // setTimeout(() => {
        //     resolve(ORDER_MOCK);
        // });
    });
};

const createOrderRequest = () => ({
    type: Types.CREATE_ORDER_REQUEST
});

const createOrderSuccess = (data) => ({
    type: Types.CREATE_ORDER_SUCCESS,
    data
});

const createOrderFailure = (error) => ({
    type: Types.CREATE_ORDER_FAILURE,
    error
});

const createOrder = (params = {}) => (dispatch, getState) => {
    dispatch(createOrderRequest());
    const { user: { secureToken, gaId, affiliateSource: source, isAffiliate, userGeoData = {} },  carDetails: { content, config },
        filters: {allFilters, appliedFilters, selectedSort, listingType } } = getState();
    const {postalCode = ""} = userGeoData || {};
    const refSource = parseCookie(REFERRER_SOURCE) || "origin";
    const customHeader = {
        referrerSource: isAffiliate ? source : refSource,
        pincode: postalCode,
        "X-Location-Data": JSON.stringify(userGeoData || {})
    };
    const {clientId = ""} = JSON.parse(parseCookie("trackingConsent")) || {};
    return new Promise((resolve, reject) => {
        CheckoutService.createOrder({...params, clientId: gaId || clientId}, secureToken, API_SOURCE.WEB_APP, customHeader)
            .then(response => {
                dispatch(createOrderSuccess(response.data));
                resolve(response.data);
                // resolve(ORDER_MOCK_1);
                // dispatch(createOrderSuccess(ORDER_MOCK_1));
            })
            .catch(error => {
                dispatch(createOrderFailure(error));
                reject(error);
            });
        // setTimeout(() => {
        //     resolve(ORDER_MOCK);
        // });
    });
};

const setFinanceUpdatedData = ({
    creditScore,
    downPayment,
    emi,
    tenure,
    chargeList
}) => ({
    type: Types.SET_FINANCE_UPDATED_DATA,
    creditScore,
    downPayment,
    emi,
    tenure,
    chargeList
});

const fetchFinance = (vehiclePrice) => (dispatch) => {
    return new Promise((resolve, reject) => {
        CheckoutService.fetchFinanceDetail(vehiclePrice)
            .then(response => {
                const { data } = response;
                dispatch(setFinanceData(data));
                resolve(response.data);
            })
            .catch(err => reject(err));
    });
};

const updateFinancePersonalDetail = (params, orderId, token) => () => {
    return new Promise((resolve, reject) => {
        CheckoutService.updateFinancePersonalDetail(params, orderId, token)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

const updateFinanceDetailRequest = () => ({
    type: Types.UPDATE_FINANCE_DETAILS
});
const updateFinanceDetailSuccess = (data) => ({
    type: Types.UPDATE_FINANCE_DETAILS_SUCCESS,
    data
});
const updateFinanceDetailFailure = (error) => ({
    type: Types.UPDATE_FINANCE_DETAILS_FAILURE,
    error
});

const updateFinanceDetail = (params = {}) => (dispatch, getState) => {
    dispatch(updateFinanceDetailRequest());
    const {
        user: { secureToken },
        checkout: {
            order,
            order: { orderId }
        }
    } = getState();
    return new Promise((resolve, reject) => {
        CheckoutService.updateFinanceDetail({ ...order, ...params}, orderId, secureToken)
            .then(response => {
                dispatch(updateFinanceDetailSuccess(response.data));
                resolve(response.data);
            })
            .catch(error => {
                dispatch(updateFinanceDetailFailure(error));
                reject(error);
            });
    });
};

const updateDeliveryModeSuccess = (data) => ({
    type: Types.UPDATE_DELIVERY_MODE_SUCCESS,
    data
});

const updateDeliveryModeFailure = (error) => ({
    type: Types.UPDATE_DELIVERY_MODE_FAILURE,
    error
});

const updateDeliveryMode = (order, orderId, token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        CheckoutService.updateDeliveryMode(order, orderId, token).then((response) => {
            dispatch(updateDeliveryModeSuccess(response.data));
            resolve();
        }).catch(error => {
            dispatch(updateDeliveryModeFailure(error));
            reject(error);
        });
    });
};

const initiateOrderPaymentRequest = () => ({
    type: Types.INITIATE_ORDER_PAYMENT_REQUEST
});

const initiateOrderPayment = (orderId, payload) => (dispatch, getState) => {
    dispatch(initiateOrderPaymentRequest());
    const {
        user: {
            secureToken
        }
    } = getState();
    return new Promise((resolve, reject) => {
        BffPaymentService.initiateOrderPayment(orderId, payload, secureToken).then((response) => {
            if (response?.data?.errorResponse?.message) {
                const {message = ""} = response?.data?.errorResponse || {};
                dispatch(showToast({ variant: "black", text: message || "Something went wrong", position: "middle"}));
                reject(response?.data);
            }
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    });
};

const getStripePublicKey = () => (dispatch, getState) => {
    const {
        user: {
            secureToken
        }
    } = getState();

    return new Promise((resolve, reject) => {
        PaymentServiceAu.getStripePublicKey(secureToken).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    });
};

const getPaymentStatusRequest = () => ({
    type: Types.GET_PAYMENT_STATUS
});

const getPaymentStatus = (orderId) => (dispatch, getState) => {
    dispatch(getPaymentStatusRequest());
    const { user: { secureToken } } = getState();
    return new Promise((resolve, reject) => {
        CheckoutService.getPaymentStatus(orderId, secureToken).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    });
};

const updateOrderBooking = (orderId, token) => () => {
    return new Promise((resolve, reject) => {
        CheckoutService.updateOrderBooking(orderId, token).then((data) => {
            resolve(data);
        });
    });
};

const setDeliveryMode = ({ deliveryMode }) => ({
    type: Types.SET_DELIVERY_MODE,
    deliveryMode
});

const setFinanceChargeList = ({ financeChargeList }) => ({
    type: Types.SET_FINANCE_CHARGE_LIST,
    financeChargeList
});

const setFinancingTab = ({ financingTab }) => ({
    type: Types.SET_FINANCING_TAB,
    financingTab
});

const setFinancingScreen = ({ activeScreen }) => ({
    type: Types.SET_FINANCE_SCREEN,
    activeScreen
});

const setFinancePersonalDetails = (data) => ({
    type: Types.SET_FINANCE_PERSONAL_DETAILS,
    data
});

const cancelOrder = (orderId, token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        CheckoutService.cancelOrder(orderId, token)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                dispatch(createOrderFailure(error));
                reject(error);
            });
    });
};

const softResetCheckoutData = () => dispatch => {
    dispatch({ type: Types.SOFT_RESET_CHECKOUT });
};

const resetCheckoutData = () => dispatch => {
    dispatch({ type: resetReducerKeys.RESET_CHECKOUT });
};

// const updateVisitedSteps = (step) => ({
//     type: Types.UPDATE_VISITED_STEPS,
//     step
// });

const setMaxStep = (maxStep) => ({type: Types.SET_MAX_STEP, maxStep});

const sendMobileOTP = () => (dispatch, getState) => {
    const {
        checkout: {
            personalDetails: { phone }
        }
    } = getState();

    return new Promise((resolve, reject) => {
        UserAuthService.sendOTP(phone, AUTH_ADDRESS.PHONE)
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
};

// BYOF Actions start
const getByoLoanInit = () => ({
    type: Types.GET_BYO_LOAN_INIT
});

const getByoLoanSuccess = (data) => ({
    type: Types.GET_BYO_LOAN_SUCCESS,
    data
});

const getByoLoanFailure = (error) => ({
    type: Types.GET_BYO_LOAN_FAILURE,
    error
});

const getByoLoan = (params = {}) => (dispatch, getState) => {
    dispatch(getByoLoanInit());
    const {
        user: { secureToken },
        checkout: { order }
    } = getState();
    const {orderId} = order || {};
    return new Promise((resolve, reject) => {
        B2cConsumerFinanceService.getBYODetails(secureToken, orderId).then(response => {
            dispatch(getByoLoanSuccess(response.data));
            resolve(response.data);
        }).catch(error => {
            dispatch(getByoLoanFailure(error));
            reject(error);
        });
    });
};

const updateByoLoanInit = () => ({
    type: Types.UPDATE_BYO_LOAN_INIT
});

const updateByoLoanSuccess = (data) => ({
    type: Types.UPDATE_BYO_LOAN_SUCCESS,
    data
});

const updateByoLoanFailure = (error) => ({
    type: Types.UPDATE_BYO_LOAN_FAILURE,
    error
});

const updateByoLoan = (params = {}) => async (dispatch, getState) => {
    dispatch(updateByoLoanInit());
    const {
        user: { secureToken },
        checkout: { order }
    } = getState();
    const {orderId, appointmentId} = order || {};
    try {
        const response = await B2cConsumerFinanceService.updateBYODetails(secureToken, {...params, orderId, appointmentId});
        dispatch(updateByoLoanSuccess(response.data));
        Promise.resolve(response.data);
    } catch (error) {
        // eslint-disable-next-line no-magic-numbers
        if (error.errorCode === NUMBER.THOUSAND_THREE) {
            const response =  await B2cConsumerFinanceService.addBYODetails(secureToken, {...params, orderId, appointmentId});
            dispatch(updateByoLoanSuccess(response.data));
            Promise.resolve(response.data);
        } else {
            dispatch(updateByoLoanFailure(error));
            Promise.reject(error);
        }

    }
};

// const addByoLoan = (params = {}) => (dispatch, getState) => {
//     dispatch(updateByoLoanInit());
//     const data = getPreApprovedPayload(params, getState());
//     return new Promise((resolve, reject) => {
//         B2cConsumerFinanceService.addBYODetails(data.payload).then(response => {
//             dispatch(updateByoLoanSuccess(response.data));
//             resolve(response.data);
//         }).catch(error => {
//             dispatch(updateByoLoanFailure(error));
//             reject(error);
//         });
//     });
// };

// BYOF Actions ends
const getLoanOfferDetailsRequest = () => ({
    type: Types.GET_LOAN_OFFER_REQUEST
});

const getLoanOfferDetailsSuccess = (data) => ({
    type: Types.GET_LOAN_OFFER_SUCCESS,
    data
});

const getLoanOfferDetailsFailure = (error) => ({
    type: Types.GET_LOAN_OFFER_FAILURE,
    error
});

const getLoanOfferDetails = () =>
    async  (dispatch, getState) => {
        dispatch(getLoanOfferDetailsRequest());
        const {
            user: { secureToken },
            checkout: {
                order: { orderId, status}
            }
        } = getState();
        try {
            let response;
            if (status === ORDER_STATUS.CREATED) {
                response = await CheckoutDrivaService.getLoanOfferDetails(orderId, secureToken);
            } else {
                response =  await CheckoutDrivaService.getCurrentOrderLoan(secureToken, orderId);
            }
            dispatch(getLoanOfferDetailsSuccess(response.data));
            return Promise.resolve(response.data);
        } catch (error) {
            dispatch(getLoanOfferDetailsFailure(error));
            return  Promise.reject(error);
        }
    };

const createLoanOfferRequest = () => ({
    type: Types.CREATE_LOAN_OFFER_REQUEST
});

const createLoanOfferSuccess = (data) => ({
    type: Types.CREATE_LOAN_OFFER_SUCCESS,
    data
});

const createLoanOfferFailure = (error) => ({
    type: Types.CREATE_LOAN_OFFER_FAILURE,
    error
});

const createLoanOffer = (params = { submitted: false }) =>
    (dispatch, getState) => {
        dispatch(createLoanOfferRequest());
        const {
            user: {
                secureToken,
                firstName,
                middleName,
                lastName,
                mobile,
                email = ""
            },
            checkout: {
                financeData,
                egcData,
                tradeinOpted,
                tradeInData: {
                    offeredPrice,
                    expired,
                    accepted
                },
                order: {
                    orderId,
                    deliveryAddress,
                    chargeDetails
                }
            },
            preApprovalLoan: {
                financeData: preApprovalFinanceData
            },
            carDetails: {
                content: {
                    appointmentId,
                    make,
                    model,
                    year,
                    price,
                    personalised
                }
            },
            myBookings: {
                paymentSummaryData: {
                    dapSummary: {
                        aggregatedItem: {
                            amount: dapAmount = 0
                        } = {}
                    } = {},
                    summary: {
                        aggregatedItem: {
                            isPayableToUser = false
                        } = {}
                    } = {},
                    totalDap: totalDapWithoutTradein = 0
                }
            }
        } = getState();
        const { totalDap, tradeInPrice } = getTradePriceLabel({dapPrice: dapAmount, totalDapWithoutTradein, egcData,  tradeinOpted, isPayableToUser});
        let driveAwayPrice = (tradeinOpted && !expired && accepted) ? Math.round(tradeInPrice.value) : Math.round(totalDap.value || price);
        const preApprovalloanDetails = getLoanDepositAmount(driveAwayPrice, preApprovalFinanceData);
        driveAwayPrice  += getSum(chargeDetails);
        const financeDataUpdated = {
            ...(personalised ? preApprovalFinanceData : financeData),
            submitted: true,
            driveAwayPrice: (tradeinOpted && !expired && accepted) ? Math.round(tradeInPrice.value) : Math.round(totalDap.value || price),
            loan: personalised ? preApprovalloanDetails : financeData.loan,
            user: {
                ...(personalised ? preApprovalFinanceData.user : financeData.user),
                email,
                firstName,
                middleName,
                lastName,
                mobile
            },
            extra: {
                ...financeData.extra,
                vehicleMake: make,
                vehicleModel: model,
                vehicleState: "used",
                vehicleYear: year,
                warrantyFinanced: !!(chargeDetails || []).find(item => item.key === EXTENDEDWARRANTY)
            }
        };
        const payload = { ...financeDataUpdated, ...params, appointmentId };
        return new Promise((resolve, reject) => {
            CheckoutDrivaService.createLoanOffer(payload, orderId, secureToken)
                .then((response) => {
                    dispatch(createLoanOfferSuccess(response.data));
                    resolve(response.data);
                })
                .catch((error) => {
                    dispatch(showToast({ variant: "black", text: "Something went wrong. Please try again.", position: "middle"}));
                    dispatch(createLoanOfferFailure(error));
                    reject(error);
                });
        });
    };

const updateLoanOfferRequest = () => ({
    type: Types.UPDATE_LOAN_OFFER_REQUEST
});

const updateLoanOfferSuccess = (data) => {
    return {
        type: Types.UPDATE_LOAN_OFFER_SUCCESS,
        data
    };
};

const updateLoanOfferFailure = (error) => ({
    type: Types.UPDATE_LOAN_OFFER_FAILURE,
    error
});

const updateLoanOffer = (params = { submitted: false }) =>
    (dispatch, getState) => {
        dispatch(updateLoanOfferRequest());
        const {
            user: { secureToken, email,
                firstName,
                middleName,
                lastName,
                mobile },
            checkout: {
                financeData,
                egcData,
                tradeinOpted,
                tradeInData: {
                    offeredPrice,
                    expired,
                    accepted
                },
                order: { orderId, chargeDetails, deliveryMode }
            },
            carDetails: {
                content: {
                    appointmentId,
                    make,
                    model,
                    year,
                    price
                }
            },
            deliveryInfo: {
                shippingPrice,
                pickupCharges
            },
            myBookings: {
                paymentSummaryData: {

                    dapSummary: {
                        aggregatedItem: {
                            amount: dapAmount = 0
                        } = {}
                    } = {},
                    summary: {
                        aggregatedItem: {
                            isPayableToUser = false
                        } = {}
                    } = {},
                    totalDap: totalDapWithoutTradein = 0
                }
            }
        } = getState();
        const { totalDap, tradeInPrice } = getTradePriceLabel({dapPrice: dapAmount, totalDapWithoutTradein, egcData,  tradeinOpted, deliveryMode, isPayableToUser});
        let  driveAwayPrice = (tradeinOpted && !expired && accepted) ? Math.round(tradeInPrice.value) : Math.round(totalDap.value || price);
        driveAwayPrice += getSum(chargeDetails);
        const financeDataUpdated = {
            ...financeData,
            driveAwayPrice,
            user: {
                ...financeData.user,
                email,
                mobile
            },
            extra: {
                ...financeData.extra,
                vehicleMake: make,
                vehicleModel: model,
                vehicleState: VEHICLE_STATE.USED,
                vehicleYear: year
            }
        };
        const payload = { ...financeDataUpdated, appointmentId, ...params };
        return new Promise((resolve, reject) => {
            CheckoutDrivaService.updateLoanOffer(payload, orderId, secureToken)
                .then((response) => {
                    dispatch(updateLoanOfferSuccess(response.data));
                    resolve(response.data);
                })
                .catch((error) => {
                    dispatch(showToast({ variant: "black", text: "Something went wrong. Please try again.", position: "middle"}));
                    dispatch(updateLoanOfferFailure(error));
                    reject(error);
                });
        });
    };

const setRecalculateTriggered = (recalculateTriggered) => ({
    type: Types.SET_RECALCULATE_TRIGGERED,
    recalculateTriggered
});

const requestCallback = () => (dispatch, getState) => {
    const {
        user: { secureToken },
        checkout: {
            order: { orderId }
        }
    } = getState();
    return new Promise((resolve, reject) => {
        CheckoutService.requestCallBack({}, orderId,  secureToken)
            .then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const fetchEgcPriceInit = () => ({
    type: Types.FETCH_EGC_PRICE
});

const fetchEgcPriceSuccess = (data) => ({
    type: Types.FETCH_EGC_PRICE_SUCCESS,
    data
});

const fetchEgcPriceFailure = (error) => ({
    type: Types.FETCH_EGC_PRICE_FAILURE,
    error
});

const fetchEgcPrice = (carId, state) => (dispatch) => {
    dispatch(fetchEgcPriceInit());
    const postalCode = state ? `state=${state}` : "";
    return new Promise((resolve, reject) => {
        ListingServiceAU.fetchCarPricing(carId, postalCode)
            .then(response => {
                dispatch(fetchEgcPriceSuccess(response.data));
                resolve(response.data);
            })
            .catch(error => {
                dispatch(fetchEgcPriceFailure([]));
                reject([]);
            });
    });
};

//Trade-in
const getTradeInDetailsRequest = () => ({
    type: Types.GET_TRADE_IN_REQUEST
});

const getTradeInDetailsSuccess = (data) => ({
    type: Types.GET_TRADE_IN_SUCCESS,
    data
});

const getTradeInDetailsFailure = (error) => ({
    type: Types.GET_TRADE_IN_FAILURE,
    error
});

const getTradeInDetails = () =>
    async (dispatch, getState) => {
        dispatch(getTradeInDetailsRequest());
        const {
            user: { secureToken },
            checkout: {
                order: { orderId, status}
            }} = getState();
        try {
            let response;
            if (status === ORDER_STATUS.CREATED) {
                response = await CheckoutTradeInService.getTradeInDetails(secureToken);
            } else {
                response =  await CheckoutTradeInService.getPostOrderTradeDetail(secureToken, orderId);
            }
            dispatch(getTradeInDetailsSuccess(response.data));
            return Promise.resolve(response.data);
        } catch (error) {
            dispatch(getTradeInDetailsFailure(error));
            return Promise.reject(error);
        }
    };

const createTradeInRequest = () => ({
    type: Types.CREATE_TRADE_IN_REQUEST
});

const createTradeInSuccess = (data) => ({
    type: Types.CREATE_TRADE_IN_SUCCESS,
    data
});

const createTradeInFailure = (error) => ({
    type: Types.CREATE_TRADE_IN_FAILURE,
    error
});

const createTradeIn = (params = { submitted: false }) =>
    (dispatch, getState) => {
        dispatch(createTradeInRequest());
        const {
            user: {
                secureToken,
                email
            },
            checkout: {
                order: {
                    orderId,
                    currency
                }
            },
            carDetails: {
                content: {
                    appointmentId
                }
            }
        } = getState();
        const payload = {
            userEmail: email,
            appointmentId,
            currency,
            ...params,
            vehicleType: X_VEHICLE_TYPE.CAR
        };
        return new Promise((resolve, reject) => {
            CheckoutTradeInService.createTradeIn(payload, orderId, secureToken)
                .then((response) => {
                    dispatch(createTradeInSuccess(response.data));
                    resolve(response.data);
                })
                .catch((error) => {
                    dispatch(createTradeInFailure(error));
                    reject(error);
                });
        });
    };

const updateTradeInRequest = () => ({
    type: Types.UPDATE_TRADE_IN_REQUEST
});

const updateTradeInSuccess = (data) => {
    return {
        type: Types.UPDATE_TRADE_IN_SUCCESS,
        data
    };
};

const updateTradeInFailure = (error) => ({
    type: Types.UPDATE_TRADE_IN_FAILURE,
    error
});

const updateTradeIn = (params = { submitted: false }) =>
    (dispatch, getState) => {
        dispatch(updateTradeInRequest());
        const {
            user: {
                secureToken,
                email
            },
            checkout: {
                order: {
                    orderId,
                    currency
                }
            }
        } = getState();
        const payload = {
            userEmail: email,
            ...params,
            currency,
            vehicleType: X_VEHICLE_TYPE.CAR
        };
        return new Promise((resolve, reject) => {
            CheckoutTradeInService.updateTradeIn(payload, orderId, secureToken)
                .then((response) => {
                    dispatch(updateTradeInSuccess(response.data));
                    resolve(response.data);
                })
                .catch((error) => {
                    dispatch(updateTradeInFailure(error));
                    reject(error);
                });
        });
    };

const customerOptedTrade = (tradeinOpted) => ({
    type: Types.SET_TRADE_OPTION,
    tradeinOpted
});

const fetchTradeInStateRequest = () => ({
    type: Types.GET_TRADE_IN_STATE_REQUEST
});

const fetchTradeInStateSuccess = (tradeInStates) => ({
    type: Types.GET_TRADE_IN_STATE_SUCCESS,
    tradeInStates
});

const fetchTradeInStateFailure = (error) => ({
    type: Types.GET_TRADE_IN_STATE_FAILURE,
    error
});

const getTradeInState = () => async (dispatch, getState) => {
    dispatch(fetchTradeInStateRequest());
    const { user: { secureToken }} = getState();
    try {
        const response = await CheckoutTradeInService.getTradeInStates(secureToken);
        const stateValue = response.data.reduce((acc, data) => {
            acc.push({ ...data, label: data.stateName, value: data.stateName});
            return acc;
        }, []);
        dispatch(fetchTradeInStateSuccess(stateValue));
        return response;
    } catch (error) {
        dispatch(fetchTradeInStateFailure(error));
        return error;
    }
};

const updateOrderTradeDetailRequest = () => ({
    type: Types.UPDATE_FINANCE_DETAILS
});

const updateOrderTradeDetailSuccess = (data) => ({
    type: Types.UPDATE_FINANCE_DETAILS_SUCCESS,
    data
});
const updateOrderTradeDetailFailure = (error) => ({
    type: Types.UPDATE_FINANCE_DETAILS_FAILURE,
    error
});

const updateOrderTradeDetail = (params = {}) => (dispatch, getState) => {
    dispatch(updateOrderTradeDetailRequest());
    const {
        user: { secureToken },
        checkout: {
            order,
            order: { orderId }
        }
    } = getState();
    return new Promise((resolve, reject) => {
        CheckoutService.updateFinanceDetail({ ...order, ...params}, orderId, secureToken)
            .then(response => {
                dispatch(updateOrderTradeDetailSuccess(response.data));
                resolve(response.data);
            })
            .catch(error => {
                dispatch(updateOrderTradeDetailFailure(error));
                reject(error);
            });
    });
};

const saveCheckoutSourcePathname = (data) => ({
    type: Types.SAVE_CHECKOUT_SOURCE_PATHNAME,
    data
});

const setSplitPayment = (data = {}) => ({
    type: Types.SET_SPLIT_PAYMENT,
    data
});

const updateSplitPaymentRequest = () => ({
    type: Types.UPDATE_SPLIT_PAYMENT
});

const updateSplitPaymentSuccess = (data) => ({
    type: Types.UPDATE_SPLIT_PAYMENT_SUCCESS,
    data
});

const updateSplitPaymentFailure = (error) => ({
    type: Types.UPDATE_SPLIT_PAYMENT_FAILURE,
    error
});

const updateSplitPayment = (params = {}) => (dispatch, getState) => {
    dispatch(updateSplitPaymentRequest());
    const {
        user: { secureToken },
        checkout: {
            order,
            order: { orderId }
        }
    } = getState();
    return new Promise((resolve, reject) => {
        CheckoutService.updateSplitPayment({...params}, orderId, secureToken)
            .then(response => {
                dispatch(updateSplitPaymentSuccess(response.data));
                dispatch(getOrderDetailSuccess(response.data));
                resolve(response.data);
            })
            .catch(error => {
                dispatch(updateSplitPaymentFailure(error));
                reject(error);
            });
    });
};

const setSplitPaymentUserState = (data = {}) => ({
    type: Types.SET_SPLIT_PAYMENT_USER_STATE,
    data
});

const getPaymentHistoryInit  = (data) => ({
    type: Types.GET_PAYMENT_HISTORY_INIT,
    data
});

const getPaymentHistorySuccess = (data) => ({
    type: Types.GET_PAYMENT_HISTORY_SUCCESS,
    data
});

const getPaymentHistoryFailure = (error) => ({
    type: Types.GET_PAYMENT_HISTORY_FAILURE,
    error
});

const getPaymentHistory = () => (dispatch, getState) => {
    dispatch(getPaymentHistoryInit());
    const {
        user: { secureToken },
        checkout: {
            order: { orderId }
        }
    } = getState();
    return new Promise((resolve, reject) => {
        CheckoutService.getPaymentHistory(orderId, secureToken)
            .then(response => {
                dispatch(getPaymentHistorySuccess(response.data));
                resolve(response.data);
            })
            .catch(error => {
                dispatch(getPaymentHistoryFailure(error));
                reject(error);
            });
    });
};

const getSignContractInit  = (data) => ({
    type: Types.GET_SIGN_CONTRACT_INIT,
    data
});

const getSignContractSuccess = (data) => ({
    type: Types.GET_SIGN_CONTRACT_SUCCESS,
    data
});

const getSignContractFailure = (error) => ({
    type: Types.GET_SIGN_CONTRACT_FAILURE,
    error
});

const getSignContract = () => (dispatch, getState) => {
    dispatch(getSignContractInit());
    const {
        user: { secureToken },
        checkout: {
            order: { orderId }
        }
    } = getState();
    return new Promise((resolve, reject) => {
        SignContractService.getSignContract(orderId, secureToken)
            .then(response => {
                const data = response.data && response.data.data;
                dispatch(getSignContractSuccess(data));
                resolve(data);
            })
            .catch(error => {
                dispatch(getSignContractFailure(error));
                reject(error);
            });
    });
};

const postSignContractInit  = (data) => ({
    type: Types.POST_SIGN_CONTRACT_INIT,
    data
});

const postSignContractSuccess = (data) => ({
    type: Types.POST_SIGN_CONTRACT_SUCCESS,
    data
});

const postSignContractFailure = (error) => ({
    type: Types.POST_SIGN_CONTRACT_FAILURE,
    error
});

const signContractPollStatus = (data) => ({
    type: Types.SIGN_CONTRACT_POLL_STATUS,
    data
});

const postSignContract = (params) => (dispatch, getState) => {
    dispatch(postSignContractInit(false));
    const {
        user: { secureToken }
    } = getState();
    return new Promise((resolve, reject) => {
        SignContractService.postSignContract(params, secureToken)
            .then(response => {
                dispatch(postSignContractSuccess(response.data));
                resolve(response.data);
            })
            .catch(error => {
                dispatch(postSignContractFailure(error));
                reject(error);
            });
    });
};

const updateSignContractStatus = (params) => (dispatch, getState) => {
    dispatch(postSignContractInit(false));
    const {
        user: { secureToken }
    } = getState();
    return new Promise((resolve, reject) => {
        SignContractService.updateSignContractStatus(params, secureToken)
            .then(response => {
                dispatch(postSignContractSuccess(response.data));
                resolve(response.data);
            })
            .catch(error => {
                dispatch(postSignContractFailure(error));
                reject(error);
            });
    });
};

const paymentInit = (data) => ({
    type: Types.PAYMENT_INIT,
    data
});

const setCurrentDeliveryStep = (data) => ({
    type: Types.SET_CURRENT_DELIVERY_STEP,
    data
});

//Trade vechicle Details
const getTradeVehicleDetailsRequest = () => ({
    type: Types.GET_TRADE_IN_VEHICLE_REQUEST
});

const getTradeVehicleDetailsSuccess = ({data}) => ({
    type: Types.GET_TRADE_IN_VEHICLE_SUCCESS,
    data
});

const getTradeVehicleDetailsFailure = (error) => ({
    type: Types.GET_TRADE_IN_VEHICLE_FAILURE,
    error
});

const getTradeVehicleDetails = (params = {}) =>
    async (dispatch, getState) => {
        dispatch(getTradeVehicleDetailsRequest());
        const { user: { secureToken }} = getState();
        try {
            const response =  await CheckoutTradeInService.getTradeInVehicleDetails(secureToken, params);
            dispatch(getTradeVehicleDetailsSuccess(response.data));
            return Promise.resolve(response.data);
        } catch (error) {
            dispatch(getTradeVehicleDetailsFailure(error));
            return Promise.reject(error);
        }
    };

const updateBasicHubspotRequest = () => ({
    type: Types.UPDATE_BASIC_HUBSPOT_INIT
});

const updateBasicHubspotSuccess = ({data}) => ({
    type: Types.UPDATE_BASIC_HUBSPOT_SUCCESS,
    data
});

const updateBasicHubspotFailure = (error) => ({
    type: Types.UPDATE_BASIC_HUBSPOT_FAILURE,
    error
});

const updateBasicHubspot = (orderId, params) => (dispatch, getState) => {
    dispatch(updateBasicHubspotRequest());
    const {
        user: { secureToken }
    } = getState();
    return new Promise((resolve, reject) => {
        CheckoutService.hubSpotBasicUpdate(orderId, secureToken, params)
            .then(response => {
                dispatch(updateBasicHubspotSuccess(response.data));
                resolve(response.data);
            })
            .catch(error => {
                dispatch(updateBasicHubspotFailure(error));
                reject(error);
            });
    });
};

// Promo code

const getPromoCodeInit = () => ({
    type: Types.GET_PROMO_CODE_REQUEST
});

const getPromoCodeSuccess = ({data}) => ({
    type: Types.GET_PROMO_CODE_SUCCESS,
    data
});

const getPromoCodeFailure = (error) => ({
    type: Types.GET_PROMO_CODE_FAILURE,
    error
});

const getPromoCodeDetails = (params = {}) =>
    async (dispatch, getState) => {
        dispatch(getPromoCodeInit());
        const { user: { secureToken }} = getState();
        try {
            const response =  {};
            dispatch(getPromoCodeSuccess(response.data));
            return Promise.resolve(response.data);
        } catch (error) {
            dispatch(getPromoCodeFailure(error));
            return Promise.reject(error);
        }
    };

const applyPromoCodeInit = () => ({
    type: Types.POST_PROMO_CODE_REQUEST
});

const applyPromoCodeSuccess = (data) => ({
    type: Types.POST_PROMO_CODE_SUCCESS,
    data
});

const applyPromoCodeFailure = (error) => ({
    type: Types.POST_PROMO_CODE_FAILURE,
    error
});

const applyPromoCode = (orderId, params = {}) =>
    async (dispatch, getState) => {
        dispatch(applyPromoCodeInit());
        const { user: { secureToken } } = getState();
        // const payload = {request: params, tag: "AU"};
        try {
            const response =  await BffPaymentService.applyCoupon(secureToken, orderId, params);
            dispatch(applyPromoCodeSuccess(response.data));
            return Promise.resolve(response.data);
        } catch (error) {
            dispatch(applyPromoCodeFailure(error));
            return Promise.reject(error);
        }
    };
const removePromoCodeInit = () => ({
    type: Types.REMOVE_PROMO_CODE_REQUEST
});

const removePromoCodeSuccess = (data) => ({
    type: Types.REMOVE_PROMO_CODE_SUCCESS,
    data
});

const removePromoCodeFailure = (error) => ({
    type: Types.REMOVE_PROMO_CODE_FAILURE,
    error
});

const removePromoCode = (orderId, params = {}) =>
    async (dispatch, getState) => {
        dispatch(removePromoCodeInit());
        const { user: { secureToken }} = getState();
        // const payload = {request: params, tag: "AU"};
        try {
            const response =  await BffPaymentService.removeCoupon(secureToken, orderId, params);
            dispatch(removePromoCodeSuccess(response.data));
            return Promise.resolve(response.data);
        } catch (error) {
            dispatch(removePromoCodeFailure(error));
            return Promise.reject(error);
        }
    };

const resetApplyPromoCode = () => ({
    type: Types.RESET_POST_PROMO_CODE
});

const getWarrantyPlansInit = () => ({
    type: Types.GET_WARRANTY_PLANS_REQUEST
});

const getWarrantyPlansSuccess = (data) => ({
    type: Types.GET_WARRANTY_PLANS_SUCCESS,
    data
});

const getWarrantyPlansFailure = (error) => ({
    type: Types.GET_WARRANTY_PLANS_FAILURE,
    error
});

const getWarrantyPlans = (params = {}) => async (dispatch, getState) => {
    dispatch(getWarrantyPlansInit());
    const {
        user: { secureToken },
        checkout: {
            order: { appointmentId }
        }} = getState();
    const modifiedParam = `?appointmentId=${appointmentId}`;
    try {
        const response =  await ListingServiceAU.getWarrantyPlans(secureToken, modifiedParam);
        dispatch(getWarrantyPlansSuccess(response.data));
        return Promise.resolve(response.data);
    } catch (error) {
        dispatch(getWarrantyPlansFailure(error));
        return Promise.reject(error);
    }
};

const updateWarrantyPlansInit = () => ({
    type: Types.UPDATE_WARRANTY_PLANS_REQUEST
});

const updateWarrantyPlansSuccess = (data) => ({
    type: Types.UPDATE_WARRANTY_PLANS_SUCCESS,
    data
});

const updateWarrantyPlansFailure = (error) => ({
    type: Types.UPDATE_WARRANTY_PLANS_FAILURE,
    error
});

const updateWarrantyPlans = (orderId, params = {}) => async (dispatch, getState) => {
    dispatch(updateWarrantyPlansInit());
    const { user: { secureToken }} = getState();
    // const payload = {request: params, tag: "AU"};
    try {
        const response =  await CheckoutService.updateWarrantyPlans(secureToken, orderId, params);
        dispatch(updateWarrantyPlansSuccess(response.data));
        dispatch(getOrderDetailSuccess(response.data));
        return Promise.resolve(response.data);
    } catch (error) {
        dispatch(updateWarrantyPlansFailure(error));
        return Promise.reject(error);
    }
};

const createTestDriveAvailabilityInit = () => ({
    type: Types.CREATE_TEST_DRIVE_AVAILABILITY_REQUEST
});

const createTestDriveAvailabilitySuccess = (data) => ({
    type: Types.CREATE_TEST_DRIVE_AVAILABILITY_SUCCESS,
    data
});

const createTestDriveAvailabilityFailure = (error) => ({
    type: Types.CREATE_TEST_DRIVE_AVAILABILITY_FAILURE,
    error
});

const createTestDriveAvailability = (payload, withLoader = true) => (dispatch, getState) => {
    dispatch(createTestDriveAvailabilityInit(withLoader));
    const {
        user: { secureToken, gaId, affiliateSource: source, isAffiliate },
        carDetails: { content, config },
        filters: {allFilters, appliedFilters, selectedSort, listingType },
        myWishlist: { wishlistedCarsList = [] }
    } = getState();
    const {clientId = ""} = JSON.parse(parseCookie("trackingConsent")) || {};

    return new Promise((resolve, reject) => {
        BffDataAU.createTestDriveAvailability(secureToken, {...payload, clientId})
            .then(response => {
                dispatch(createTestDriveAvailabilitySuccess(response.data));

                const filterDimensionsGA4 = parseFilterToDimensionGA4(allFilters, appliedFilters, selectedSort);
                const isWishlisted =  (wishlistedCarsList || []).some((car) => car === response.data.appointmentId);
                const data = carListingEventDataParser(content, {
                    list: CAR_LIST_EVENT_NAMES.DETAILS,
                    orderId: response.data.orderId,
                    excludedKeys: [
                        "list"
                    ],
                    isWishlisted
                });
                const dataGA4 = carListingEventDataParserGA4(content, {
                    filterDimensions: filterDimensionsGA4,
                    listingType,
                    isWishlisted
                });
                trackDesktopCustomEventsAU("clearEccomerce", { ecommerce: null });
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.BEGIN_CHECKOUT, {
                    ...dataGA4
                });
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.START_PURCHASE, data.startPurchase);
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.START_PURCHASE, {
                    ecomm_prodid: response.data.appointmentId,
                    ecomm_totalvalue: response.data.vehiclePrice
                });
                //Amplitude Events
                const amplitudeData = carListingAmplitude(content, { filterDimensions: filterDimensionsGA4, orderId: response.data.orderId });
                //cleverTap events
                if (isFirstCleverTapOrderEvent(CLEVERTAP_EVENT_MAP.BOOKING_INITIATED, response.data.orderId)) {
                    const biEvents = cleverTapBookingInitiated(content, { orderId: response.data.orderId, config, bookingType: CLEVERTAP_BOOKING_TYPE.TEST_DRIVE });
                    desktopCleverTapEvent(CLEVERTAP_EVENT_MAP.BOOKING_INITIATED, biEvents);
                }

                resolve(response.data);
            }).catch(error => {
                dispatch(createTestDriveAvailabilityFailure(error));
                reject(error);
            });
        // setTimeout(() => {
        //     resolve(ORDER_MOCK);
        // });
    });
};

export {
    populateCheckoutPersonalData,
    setUserPersonalDetails,
    setPersonalDetailSuccessMessage,
    fetchFinance,
    setFinanceData,
    setLoanDetails,
    setLoanType,
    setLoanTenureValue,
    setCreditScoreValue,
    setDownPaymentValue,
    setMonthlyEmiValue,
    getOrderDetail,
    updateFinancePersonalDetail,
    setDeliveryMode,
    setFinancingTab,
    setMinMaxDownPaymentValue,
    setMinMaxEmiValue,
    setFinanceSelectedValue,
    setFinancePersonalDetails,
    createOrder,
    updateFinanceDetail,
    updateDeliveryMode,
    updateOrderBooking,
    initiateOrderPayment,
    setFinanceUpdatedData,
    setFinancingScreen,
    cancelOrder,
    setFinanceChargeList,
    softResetCheckoutData,
    resetCheckoutData,
    getPaymentStatus,
    setMaxStep,
    sendMobileOTP,
    updateByoLoan,
    // updatePreApprovedLoan,
    getLoanOfferDetails,
    createLoanOffer,
    updateLoanOffer,
    // updateVisitedSteps
    setRecalculateTriggered,
    requestCallback,
    getTradeInDetails,
    createTradeIn,
    updateTradeIn,
    fetchEgcPrice,
    customerOptedTrade,
    getTradeInState,
    updateOrderTradeDetail,
    saveCheckoutSourcePathname,
    getByoLoan,
    setSplitPayment,
    updateSplitPayment,
    setSplitPaymentUserState,
    getPaymentHistory,
    getPaymentHistoryInit,
    getSignContract,
    postSignContract,
    updateSignContractStatus,
    signContractPollStatus,
    paymentInit,
    setCurrentDeliveryStep,
    getTradeVehicleDetails,
    getStripePublicKey,
    updateBasicHubspot,
    getLoanOfferDetailsSuccess,
    getPromoCodeDetails,
    applyPromoCode,
    resetApplyPromoCode,
    applyPromoCodeSuccess,
    removePromoCode,
    getWarrantyPlans,
    updateWarrantyPlans,
    createTestDriveAvailability
};
